import React, { useEffect, useState } from "react";
import {
  TextField,
  Button,
  Container,
  Typography,
  Box,
  Alert,
  CircularProgress,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import Header from "../common/Header";
import {buttonStyle, inputStyle} from "../styles";
import {BASIC_URL} from "../enum";

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("jwt");
    if (token) {
      navigate("/company");
    }
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await axios.post(`${BASIC_URL}/api/auth/local`, {
        identifier: identifier,
        password: password
      });

      const { jwt, user } = res.data;

      localStorage.setItem("jwt", jwt);
      localStorage.setItem("user", JSON.stringify(user));

      navigate("/company");
    } catch (err) {
      console.error(err);
      setError(t("login.error.invalid"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Container maxWidth="xs" sx={{ pb: 3 }}>
        <Box mt={4} mb={3}>
          <Typography variant="h4" align="center" gutterBottom>
            {t("login.title")}
          </Typography>
        </Box>

        <form onSubmit={handleLogin}>
          <TextField
            fullWidth
            margin="normal"
            label={t("login.email")}
            name="identifier"
            type="email"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            required
            sx={inputStyle}
          />
          <TextField
            fullWidth
            margin="normal"
            label={t("login.password")}
            name="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            sx={inputStyle}
          />

          <Box mt={1} mb={3} textAlign="right">
            <Button
              onClick={() => navigate("/forgot-password")}
              sx={{ textTransform: "none", fontSize: "0.9rem", color: "#0063a6" }}
            >
              {t("login.forgot")}
            </Button>
          </Box>

          <Box mt={3} position="relative">
            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={loading}
              sx={buttonStyle}
            >
              {t("login.submit")}
            </Button>
            {loading && (
              <CircularProgress
                size={24}
                sx={{ position: "absolute", top: "50%", right: "16px", mt: "-12px" }}
              />
            )}
          </Box>
        </form>

        {error && (
          <Box mt={2}>
            <Alert severity="error">{error}</Alert>
          </Box>
        )}
      </Container>
    </>
  );
};

export default Login;
